var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassAndGlazing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 21.65,
    className: "st0",
    width: 11.98,
    height: 11.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.54,
    y: 33.88,
    className: "st0",
    width: 11.99,
    height: 11.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.48,
    y: 33.88,
    className: "st0",
    width: 11.99,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,20.59h11.87V7.01l-0.79,0.07c-3.28,0.31-6.27,1.91-8.4,4.51c-2.01,2.44-2.97,5.56-2.68,8.35V20.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.53,19.87c0.26-7.26-5.6-12.46-11.25-12.76l-0.76-0.04v13.49h11.98L38.53,19.87z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.53,
    y: 21.64,
    className: "st0",
    width: 11.98,
    height: 11.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.42,51h35.24c0.68,0,0.8-0.13,0.8-0.79V19.55c0-2.41-0.46-4.8-1.38-7.09C40.34,5.61,33.45,1,25.92,1 c-2.21,0-4.36,0.4-6.41,1.19C12.13,5.04,7.54,11.72,7.54,19.63c-0.01,6.33-0.01,12.66-0.01,18.99v11.51C7.53,50.91,7.63,51,8.42,51 z M38.53,45.05H26.54V33.88h11.99V45.05z M26.53,32.81V21.64h11.98v11.17H26.53z M26.53,7.07l0.76,0.04 c5.65,0.3,11.51,5.5,11.25,12.76l-0.03,0.69H26.53V7.07z M16.28,11.59c2.13-2.6,5.12-4.2,8.4-4.51l0.79-0.07v13.58H13.6v-0.65 C13.32,17.15,14.28,14.03,16.28,11.59z M13.5,21.65h11.98v11.17H13.5V21.65z M13.48,33.88h11.99v11.18H13.48V33.88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassAndGlazing);
export default __webpack_public_path__ + "static/media/glass-and-glazing.b4a1eacc65f18d0f3ed64b23230501cf.svg";
export { ForwardRef as ReactComponent };